module.exports = __webpack_public_path__ + "static/media/joaquin.80bdf4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/joaquin.png
// module id = 1159
// module chunks = 0